import { WebGLRenderer } from "three";
import { Scene } from "three";
import { PerspectiveCamera } from "three";
import { Vector2 } from "three";
import { Raycaster } from "three";

let mouse = new Vector2();
let raycaster = new Raycaster();
export class MouseEvents {
  /**
   * this class helps you to controller events mouse
   *
   */
  constructor(
    container,
    renderer = WebGLRenderer,
    camera = PerspectiveCamera,
    scene = Scene
  ) {
    this.container = container;
    this.camera = camera;
    this.scene = scene;
    this.renderer = renderer;
    this.distanceDrag = 0;
    this.defaultInteractions();
  }
  _getInteractionMouse(e) {
    const canvasBounds = this.renderer.domElement.getBoundingClientRect();
    mouse.x =
      ((e.clientX - canvasBounds.left) /
        (canvasBounds.right - canvasBounds.left)) *
        2 -
      1;
    mouse.y =
      -(
        (e.clientY - canvasBounds.top) /
        (canvasBounds.bottom - canvasBounds.top)
      ) *
        2 +
      1;
    raycaster.setFromCamera(mouse, this.camera);
    const objects = [
      ...this.scene.children[1].children,
      ...this.scene.children[2].children,
    ];
    let intersects = raycaster.intersectObjects(objects, true);
    return intersects;
  }
  /**
   * @param [callback=1] — return object to mouse pointer.
   */
  onPoinertMove(callBack = Function) {
    this.container.onpointermove = (e) => {
      e.preventDefault();
      this.distanceDrag++;
      callBack(this._getInteractionMouse(e));
    };
  }
  onPointerUp(callBack = Function) {
    this.container.onpointerup = (e) => {
      e.preventDefault();
      if (this.distanceDrag < 15) {
        callBack(this._getInteractionMouse(e));
      }
    };
  }
  defaultInteractions() {
    this.container.onpointerdown = (e) => {
      e.preventDefault();
      this.distanceDrag = 0;
    };
  }
}
